export default function BarChart({ data = [] }) {
  const max = Math.max(...data.map((d) => d.value), 1);
  return (
    <div className="flex gap-3 items-end w-full h-40">
      {data.map((d) => (
        <div key={d.label} className="flex-1">
          <div className="relative w-full bg-gradient-to-t from-emerald-200 to-emerald-500 rounded-t-md" style={{ height: `${(d.value / max) * 100}%` }} />
          <div className="mt-2 text-[10px] text-center text-gray-500">{d.label}</div>
        </div>
      ))}
    </div>
  );
}


